export default {
  title: 'Información médica',
  titleDescription: 'Complete la siguiente información para poder continuar',
  nameLabel: 'Nombre y Apellido',
  specialtyLabel: 'Especialidad',
  license: 'No. de Exequátur',
  countryLabel: 'Pais',
  providerCode: 'Código de prestador',
  doctorTitle: "Datos del médico prescriptor",
  enterData:"Ingresa los siguientes datos",
  diagnosesTitle: "Diagnóstico(s)",
  productsTitle: "Producto(s)",
  prescriptionTitle: "Receta / Indicación",
  prescriptionDescription: "Archivos en formato PDF, PNG o JPEG, peso máximo 20Mb",
  illnessOnset: "Inicio sintomatología",
  examTitle: "Examen",
  documentToUploadTitleOptional: "{title} (Opcional)",
  buttons: {
    add: "Agregar"
  },
  noFiles: "No hay archivos adjuntos",
  diagnoses: {
    panelTitle: 'Diagnósticos',
    title: 'Diagnósticos',
    emptyDiagnoses: 'Aún no se han agregado diagnósticos',
    customDiagnosisItemListLabel: 'Diagnóstico',
    searchLabel: 'Agregar diagnóstico(s)',
    emptyList: 'No se encontraron resultados',
    addDiagnosisLabel: '+ Agregar "{value}"',
    maximumNumberOfItemsReached: 'Cantidad máxima alcanzada',
    errors: {
      repeated: 'Ya ha agregado este diagnóstico'
    },
    loading: "Cargando..."
  },
  products: {
    emptyList: 'No se encontraron resultados',
    addLabel: '+ Agregar "{value}"',
    maximumNumberOfItemsReached: 'Cantidad máxima alcanzada',
    searchLabel: 'Agregar examen',
    customDiagnosisItemListLabel: 'Examen',
  },
  fileUpload: {
    errors: {
      multipleFileUpload: "Solo puede cargar un archivo a la vez",
      fileTypeIncorrect: "Tipo de archivo incorrecto",
      fileSizeIncorrect: "El tamaño del archivo excede 20Mb",
      fileMaxAttachment: "Se ha excedido el límite de archivos",
      fileUploadError: "Hubo un problema al cargar el archivo. Por favor, intente nuevamente."
    },
    labels: {
      studiesReport: "Reporte de estudios realizados",
      prescription: "Indicación médica",
      procedureDescription: "Hoja de descripción de procedimiento realizado",
      pathologyResult: "Resultado del reporte de patología",
      anesthesiaFile: "Hoja de anestesia",
      ambulatoryCareForm: "Formulario de atención ambulatoria"
    }
  },
  validations: {
    prescription: "Ingrese los datos del médico.",
    diagnoses: "Agregue al menos un diagnóstico.",
    treatments: "Agregue al menos un producto.",
    exams: "Agregue al menos un examen.",
    receiptFile: "Agregue los archivos requeridos"
  }
}